import AbstractEditorController from './abstract-editor-controller';

class DocumentTemplatesCreateController extends AbstractEditorController {

    constructor($state, $injector) {
        super($state, $injector);
        this._loadAndStoreDeposits().then(() => {
            this.loading = false;
        });
    }

    submit(form) {
        if (form.$valid) {
            this.injector.get('DocumentTemplate').post(this.model).then(() => {
                this.allowRoute = true;
                this.alert.success(
                    this.translate.instant('documents.templates.pages.create.messages.save_success.title'),
                    this.translate.instant('documents.templates.pages.create.messages.save_success.message')
                );
                this.back();
            }, (e) => {
                this.alert.handle(e);
            });
        }
    }
}

/**
 * @ngdoc object
 * @name contacts.documents.templates:DocumentsTemplatesDetailsCtrl
 *
 * @description
 *
 */
angular
    .module('festzelt-os.documents.templates')
    .controller('DocumentsTemplatesCreateCtrl', DocumentTemplatesCreateController);



// WEBPACK FOOTER //
// ./src/app/pages/documents/templates/controllers/create-controller.js